import { Link, useLocation } from 'react-router-dom';
import userSearch from '../../assets/images/userSearch.png';

export default function SidebarUserSearch({ ctx, mode, onNavigate = () => {} }) {
  const location = useLocation();

  if (ctx.role === 'collection_user') return null;

  const isActive = location.pathname === '/usersearch';
  const className = [
    'sidebar-item',
    'sidebar-item--depth-0',
    mode === 'collapsed' ? 'sidebar-item--collapsed' : 'sidebar-item--expanded',
    isActive ? 'sidebar-item--active' : '',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <Link
      to="/usersearch"
      role="menuitem"
      aria-current={isActive ? 'page' : undefined}
      className={className}
      onClick={onNavigate}
    >
      <img src={userSearch} alt="" className="sidebar-item-icon" />
      {mode === 'expanded' && <span className="sidebar-item-label">User Search</span>}
    </Link>
  );
}
